import router from '@/router'
import { v1 as uuidv1 } from 'uuid';
import {doc, setDoc} from "firebase/firestore";
export default {
    state: {
        billingTransactionObj: null,
        billingAddress: null,
        transactionObj: null
    },
    mutations: {
        setBillingTransactionObj (state, payload) {
            state.billingTransactionObj = payload
        },
        setTransactionObj (state, payload) {
            state.transactionObj = payload
        },
        setBillingObj (state, payload) {
            state.billingAddress = payload
        },
        clearTransactionObj (state) {
            state.transactionObj = null
        },
        clearBillingTransactionObj (state) {
            state.billingTransactionObj = null
        }
    },
    actions: {
        initCardPayment ({commit}, payload) {
            commit('setTransactionObj', payload)
            router.push('/StripeCheckout')
        },
        newCardPaymentMade ({rootState, getters, commit}, payload) {
            commit('setLoading', true)
            let user = getters.user
            let chargeObj = payload
            chargeObj.id = uuidv1()
            chargeObj.status = 'Pending'

            setDoc(doc(rootState.db, 'users', user.uid, 'cardPayments', 'stripe', 'charges', chargeObj.id), chargeObj)
                .then(() => {
                    router.push('/transactionStatus/' + chargeObj.id)
                })
                .catch(err => {
                    console.log(err)
                    commit('setError', err)
                })
        },
        chargeCardOnFile ({rootState, getters, commit}, payload) {
            commit('setLoading', true)
            let user = getters.user
            let chargeObj = payload
            chargeObj.id = uuidv1()
            chargeObj.status = 'Pending'
            //console.log(chargeObj)
            // let paymentRef = rootState.db.collection('users').doc(user.uid)
            //     .collection('cardPayments').doc('stripe').collection('charges')
            // console.log('from Payment store')
            setDoc(doc(rootState.db, 'users', user.uid, 'cardPayments', 'stripe', 'charges', chargeObj.id), chargeObj)
                .then(() => {
                    router.push('/transactionStatus/' + chargeObj.id)
                })
                .catch(err => {
                    console.log(err)
                    commit('setError', err)
                })
        },
        resetTransaction ({commit}) {
            commit('clearTransactionObj')
        },


        // billing transactions
        initBillingCardPayment ({commit}, payload) {
            commit('setBillingTransactionObj', payload)
            router.push('/billingStripeCheckout')
        },
        setBillingAddress ({commit}, payload) {
            commit('setBillingObj', payload)
        },
        newBillingCardPaymentMade ({rootState, getters, commit}, payload) {
            commit('setLoading', true)
            let user = getters.user
            let chargeObj = payload
            chargeObj.user = user
            chargeObj.id = uuidv1()
            chargeObj.status = 'Pending'
            if (!chargeObj.notificationMethods) {
                chargeObj.notificationMethods = {email: true}
            }
            setDoc(doc(rootState.db, 'users', user.uid, 'billing', 'stripe', 'charges', chargeObj.id), chargeObj)
                .then(() => {
                    router.push('/billingTransactionStatus/' + chargeObj.id)
                })
                .catch(err => {
                    console.log(err)
                    commit('setError', err)
                })
        },
        chargeBillingCardOnFile ({rootState, getters, commit}, payload) {
            commit('setLoading', true)
            let user = getters.user
            let chargeObj = payload
            chargeObj.id = uuidv1()
            chargeObj.status = 'Pending'
            if (!chargeObj.notificationMethods) {
                chargeObj.notificationMethods = {email: true}
            }
            setDoc(doc(rootState.db, 'users', user.uid, 'cardPayments', 'stripe', 'charges', chargeObj.id), chargeObj)
                .then(() => {
                    router.push('/transactionStatus/' + chargeObj.id)
                })
                .catch(err => {
                    console.log(err)
                    commit('setError', err)
                })
        },
        resetBillingTransaction ({commit}) {
            commit('clearTransactionObj')
        }
    },
    getters: {
        transactionObj (state) {
            return state.transactionObj
        },
        billingTransactionObj (state) {
            return state.billingTransactionObj
        },
        billingAddress (state) {
            return state.billingAddress
        }
    }
}
